import { Typography, useMediaQuery } from '@mui/material';
import React from 'react';

const CVPolicices = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <div>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '21px' : '48px',
          fontWeight: 800,
          color: 'white',
          textAlign: 'center',
          paddingBottom: isMobile ? '20px' : '40px'
        }}>
        Privacy Policy
      </Typography>

      <ul style={{ color: 'white', margin: isMobile ? '0 5%' : '0 10%' }}>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Overview
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Champsverse is a digital platform designed to empower children aged 6–16 by allowing them to create, share,
            and showcase their talents. Children can upload artwork, write books, participate in contests, store
            certificates, and earn rewards in a gamified, collaborative environment.{' '}
          </Typography>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Given our young user base, we are deeply committed to safeguarding children&apos;s privacy and ensuring full
            compliance with applicable data protection laws, including:
          </Typography>
          <ul>
            <li style={{ fontSize: isMobile ? '14px' : '24px', fontFamily: 'Baloo2', fontWeight: 800 }}>
              Children&apos;s Online Privacy Protection Act (COPPA){' '}
              <span style={{ fontWeight: 400 }}>in the United States,</span>
            </li>
            <li style={{ fontSize: isMobile ? '14px' : '24px', fontFamily: 'Baloo2', fontWeight: 800 }}>
              General Data Protection Regulation (GDPR){' '}
              <span style={{ fontWeight: 400 }}>in the European Union, and</span>
            </li>
            <li style={{ fontSize: isMobile ? '14px' : '24px', fontFamily: 'Baloo2', fontWeight: 800 }}>
              Digital Personal Data Protection Act <span style={{ fontWeight: 400 }}>,2023 (DPDPA) in India.</span>
            </li>
          </ul>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            This Privacy Policy outlines the types of personal data we collect, how we use and protect it, and the
            choices available to parents and guardians regarding their child&apos;s data.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Information We Collect
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We collect the following personally identifiable information (PII):
          </Typography>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 800,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Parent Information:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Full Name</li>
            <li>Email Address</li>
          </ul>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 800,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Child Information:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Full Name</li>
            <li>Age</li>
            <li>Date of Birth</li>
            <li>Profile Picture</li>
            <li>Country of Residence</li>
            <li>Interests</li>
            <li>App Feedback</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          How We Use This Information
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500
            }}>
            We use the collected data to:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Create and manage accounts</li>
            <li>Facilitate participation in contests, challenges, and creative activities</li>
            <li>Display personalized content and rewards</li>
            <li>Enable the creation, sale, and display of artworks and books</li>
            <li>Maintain communication between children and their parents or guardians</li>
            <li>Ensure platform safety, user engagement, and functionality</li>
          </ul>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We do not display or share any personal information publicly without explicit consent from parents or
            guardians.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          {' '}
          Features Offered
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Champsverse includes the following features that may involve the use of personal information:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Uploading and sharing artworks and writings</li>
            <li>Uploading certificates (academic/sports)</li>
            <li>Using and redeeming virtual coins</li>
            <li>Writing and publishing books</li>
            <li>Paid and free subscription access</li>
            <li>Sending and receiving virtual gifts</li>
            <li>Participating in contests and challenges (may involve rankings or public display of work)</li>
            <li>Earning rewards for contributions</li>
            <li>Monetization of children&apos;s creative works (books, artworks)</li>
            <li>Cross-border platform access for children in multiple countries</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Parental Control & Consent
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Parental consent is required before collecting or processing any child&apos;s personal data. Parents manage
            their child&apos;s account and can:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>View their child&apos;s activities</li>
            <li>Update account information</li>
            <li>Delete their child&apos;s account</li>
            <li>Request data deletion</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Data Storage and Security
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We take data security seriously. Champsverse implements industry-standard safeguards to protect your data
            from unauthorized access, disclosure, alteration, and destruction. We retain user data only for as long as
            necessary to provide the service or as required by law.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Data Sharing and Third Parties
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We do not share personal information with third-party ad networks or use the data for advertising purposes.
          </Typography>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            In some cases, we may use third-party services (e.g., cloud storage, payment gateways, analytics). These
            providers are vetted to comply with relevant privacy regulations.{' '}
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Your Rights Over Your Data
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We are committed to ensuring transparency and giving users and their parents control over their personal
            data. Depending on your location, you or your legal guardian may have the following rights under the General
            Data Protection Regulation (GDPR), the Children&apos;s Online Privacy Protection Act (COPPA), and the
            Digital Personal Data Protection Act, 2023 (DPDPA - India):
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Be Informed
              <Typography>
                You have the right to know what personal data we collect, why we collect it, how it is processed, and
                with whom it may be shared.
              </Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Access
              <Typography>You can request access to the personal data we hold about you or your child.</Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Rectification
              <Typography>You can request that we correct inaccurate or incomplete personal data.</Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Deletion
              <Typography>You may request deletion of your personal data at any time</Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Restrict Processing
              <Typography>
                You can ask us to limit how we use your personal data under certain circumstances.
              </Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Data Portability
              <Typography>
                Where applicable, you can request a copy of your personal data in a structured, commonly used format, or
                request it be transferred to another service provider.
              </Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Object to Processing
              <Typography>You may object to the processing of your personal data for certain purposes.</Typography>
            </li>
            <li
              style={{
                fontWeight: 800
              }}>
              Right to Parental Rights (under COPPA)
              <Typography>
                Parents or guardians have the right to review, delete, and refuse further collection of their
                child&apos;s data at any time.
              </Typography>
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Data Retention
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We retain account information for as long as the account remains active. If an account is deleted, we will
            remove associated data within 30 days unless otherwise required by law.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          International Data Transfers
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            As Champsverse is accessible globally, personal data may be transferred and stored in countries outside your
            own. In such cases, we ensure appropriate safeguards are in place as required under GDPR
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Children’s Data Policy
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We prioritize the safety and privacy of young users. Our platform is not designed for children under 13, and
            we do not intentionally gather any personal data from them. If we become aware that information from a child
            under 13 has been submitted, we will take immediate steps to erase it. Parents or guardians who suspect that
            their child may have shared such information with us are encouraged to reach out so we can address the
            situation responsibly.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Contact Us
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            If you have any questions, concerns, or complaints regarding this Privacy Policy or your data, please
            contact admin@champsverse.com
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export default CVPolicices;
